// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"Yct9id1n","descriptionLoaderWrapper":"jmMwpAHa","rankLoaderWrapper":"d8VABuob","logoLoaderWrapper":"HXJxBhAi","themeNameLoaderWrapper":"Jux3p1S7"};